import React, { forwardRef } from 'react';
import { useOrganizationSettingsStore, useOrganizationStore } from '../../store/organizationSettingsStore';
import arrowIcon from '../../assets/icons/downPointingArrowOrganization.svg';
import rightArrowIcon from '../../assets/icons/sidebar/rightIconSidebarButton.svg';
import { truncateText } from '../../constants/constants';
import { Organization } from '../organizationDropdownList/organizationDropdownList';
import AccountMenu from '../accountMenu/accountMenu';

interface OrganizationDropdownButtonProps {
  handleToggle: () => void;
  isOpen: boolean;
  organizations: { data: { data: Organization[] } } | undefined;
}

const OrganizationDropdownButton = forwardRef<HTMLButtonElement, OrganizationDropdownButtonProps>((props, ref) => {
  const selectedOrganization = useOrganizationStore((state) => state.selectedOrganization);
  const { organizationSettings } = useOrganizationSettingsStore((state) => state);

  return (
    <button
      id="org-dropdown-toggle"
      onClick={props.handleToggle}
      className="flex w-full items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-2 py-2 text-sm transition-colors hover:bg-[rgba(12,72,94,0.05)]"
      ref={ref}
    >
      <AccountMenu />
      <div className="flex w-full items-center justify-between">
        {selectedOrganization
          ? (
            <div className="flex flex-col items-start">
              <p className="text-xs font-medium text-gray-700">{truncateText(selectedOrganization.name ?? '', 21)}</p>
              <span className="text-[10px] text-gray-400">{truncateText(selectedOrganization.orgName ?? '', 21)}</span>
            </div>
          )
          : (
            <div className="flex flex-col items-start">
              <span className="text-xs font-medium text-gray-700">{truncateText(organizationSettings?.name ?? '', 21)}</span>
              <span className="text-[10px] text-gray-400">
                #
                {organizationSettings.organizationId}
              </span>
            </div>
          )}

        <img
          className={`ml-1 w-4 opacity-30 transition-transform duration-200 [filter:brightness(0)] ${!props.isOpen ? 'rotate-90' : 'rotate-0'}`}
          src={rightArrowIcon}
          alt="arrow icon"
        />
      </div>
    </button>
  );
});

export default OrganizationDropdownButton;
